var constants = require('../constants');
var api = require('../../../utils/api');
var authActions = require('./auth-login');
var authLogoutActions = require('./auth-logout');
var commonActions = require('../../common/actions/common');

var authRefreshToken = (function() {

    var _refreshTokenRequest = function() {
        return {
            type: constants.AUTH_REFRESH_TOKEN_REQUEST
        };
    }

    var _refreshTokenError = function(error) {
        return {
            type: constants.AUTH_REFRESH_TOKEN_FAILURE,
            errors: error.data
        };
    }

    var _refreshToken = function(refreshToken, callback) {
        return function(dispatch) {
            dispatch(_refreshTokenRequest());
            api.post('/proxy/oauth/token', {
                    "refresh_token": refreshToken,
                    "grant_type": "refresh_token"
                })
                .then(function(data) {
                    dispatch(authActions.loginSuccess(data, false));
                })
                .catch(function(error) {
                    if(error.response){
                        dispatch(authLogoutActions.logOut());
                        dispatch(_refreshTokenError(error.response));
                    }else{
                        dispatch(commonActions.setGenericError('', error.message));
                    }
                })
        };
    }

    return {
        refreshToken: _refreshToken
    }
})();

module.exports = authRefreshToken;



// WEBPACK FOOTER //
// ./src/common/modules/auth/actions/auth-refresh-token.js